import { createTheme } from '@mui/material';

export const datagridSx = {
  borderRadius: 2,
  '& .MuiDataGrid-main': { borderRadius: 2 }
};

export const theme = createTheme({
  typography: {
    fontSize: 10,
    fontFamily: 'monospace',
    allVariants: {
      alignContent: 'center',
      textAlign: 'center'
    },
    button: {
      textAlign: 'center',
      alignContent: 'center'
    }
  }
});

const getTimezoneOffset = (value: Date) => value.getTimezoneOffset() * 60000;

export const makeLocalAppearUTC = (value: Date) => {
  const dateTime = new Date(value);
  const utcFromLocal = new Date(dateTime.getTime() + getTimezoneOffset(dateTime));
  return utcFromLocal;
};

export const localToUTC = (dateTime: Date) => {
  const utcFromLocal = new Date(dateTime.getTime() - getTimezoneOffset(dateTime));
  return utcFromLocal;
};
